import { initVideoPlay } from "@js/video-play.js";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.content_video-layout").forEach((layout) => {
        initVideoPlay(layout.querySelector("video"), layout.querySelector(".video-play"));
    });
});
